const isTouchDevice = () => matchMedia('(pointer: coarse)').matches

export const isNoTouchDevice = () => !isTouchDevice()
